import api from 'api'
import { queryParamSerializer } from 'lib/api/queryParamSerializer'

export type WebhookStatus =
  | 'created'
  | 'failed'
  | 'attempted'
  | 'invalid_payload'
  | string

export interface HighnoteWebhookEventItem {
  id: number
  status: WebhookStatus
  eventId: string | null
  eventName: string | null
  replay: boolean
  createdAt: string
  updatedAt: string
  payload: string
}

const CREATED_RETRY_AFTER_MS = 5 * 60 * 1000

const retryableStatuses: WebhookStatus[] = ['failed', 'invalid_payload']

export const isRetryable = (event: HighnoteWebhookEventItem) => {
  if (event.status === 'created') {
    return (
      Date.now() - new Date(event.createdAt).getTime() >= CREATED_RETRY_AFTER_MS
    )
  }

  return retryableStatuses.includes(event.status)
}

export type FailedNotificationTasksPage = {
  events: HighnoteWebhookEventItem[]
  previousCursor: number | null
  nextCursor: number | null
  totalCount: number
}

export type FailedNotificationTasksParams = {
  pageSize: number
  cursor?: number
  id?: number | null
  status?: string[]
  eventName?: string[]
  search?: string
}

export async function getFailedNotificationTasks(
  params: FailedNotificationTasksParams
): Promise<FailedNotificationTasksPage> {
  const search = params.search?.trim()
  const resp = await api.get<FailedNotificationTasksPage>(
    '/admin/highnote/notification_task/failed',
    {
      params: {
        pageSize: params.pageSize,
        cursor: params.cursor,
        id: params.id ?? undefined,
        status: params.status?.length ? params.status : undefined,
        eventName: params.eventName?.length ? params.eventName : undefined,
        search: search || undefined,
      },
      paramsSerializer: queryParamSerializer,
    }
  )
  return resp.data
}

export async function retryNotificationTask(eventId: number): Promise<void> {
  await api.post(`/admin/highnote/notification_task/failed/${eventId}/retry`)
}
